import RestClient from '../../../../api/axiosInterceptor';
import { doctorVerificationActions, doctorResendVerificationActions } from '../../../actions/user/doctor/verification';
import { toast } from 'react-toastify';

const createAsyncAction = (actionType, apiCall) => async (dispatch) => {
  try {
    dispatch({ type: actionType.REQUEST });
    const response = await apiCall();
    dispatch({
      type: actionType.SUCCESS,
      payload: response.data
    });
    toast.success(response.data.message, { position: 'top-center' });
  } catch (error) {
    const errorMessage = error.response?.data?.message;
    dispatch({
      type: actionType.FAILURE,
      error: errorMessage
    });
    toast.error(errorMessage, { position: 'top-center' });
  }
};

// For email verification
export const doctorVerifyEmail = (uidb64, token) =>
  createAsyncAction(
    doctorVerificationActions.EMAIL,
    () => RestClient.get(`/auth1/activate/${uidb64}/${token}/`)
  );

// For resending verification email
export const doctorResendVerificationEmail = (email) =>
  createAsyncAction(
    doctorResendVerificationActions.RESEND_VERIFICATION_EMAIL,
    () => RestClient.post('/doctors/resend-verification/', { email })
  );
